module.exports = __webpack_public_path__ + "assets/5b5467e42e4af434386d93e5bcb16111.svg";